//Transforms component into another component
//Adding additional functionalities to the existing components.

import React from "react";
import { Routes } from "react-router-dom";

//Layouts
import MovieLayout from "../Layouts/Movie.layout";

//component
//props -> path exact
const MovieHOC = ({ component: Component  }) => {
  return (
    <>
  
      <MovieLayout>
       <Component/>
      </MovieLayout>
    </>
  );
};

export default MovieHOC;